import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-center items-center w-full gap-6 mb-6 max-sm:flex-wrap flex-row" }
const _hoisted_3 = { class: "meeting-engagement-requirements-block border border-gray-200 rounded-2xl p-6 bg-white shadow-card relative h-full w-full max-sm:w-full" }
const _hoisted_4 = { class: "flex justify-between w-full" }
const _hoisted_5 = { class: "mb-1 text-gray-900 font-semibold text-lg" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  id: "engagementGraph",
  class: "w-full h-80"
}, null, -1)
const _hoisted_7 = { class: "flex w-full gap-6 flex-col" }
const _hoisted_8 = { class: "meeting-engagement-requirements-block border border-gray-200 rounded-2xl p-6 bg-white shadow-card relative w-full max-sm:overflow-x-scroll" }
const _hoisted_9 = { class: "mb-1 text-gray-900 font-semibold text-lg" }
const _hoisted_10 = {
  key: 0,
  class: "w-full flex justify-center items-center p-3"
}
const _hoisted_11 = {
  key: 1,
  class: "w-full"
}
const _hoisted_12 = { class: "px-6 py-3" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "px-6 py-3" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex justify-between items-center mt-3 mb-4 px-6" }
const _hoisted_21 = { class: "text-gray-700 text-sm font-medium" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]

import { ref, onMounted, computed } from "vue";
import * as echarts from "echarts";
import { useActivityStore } from "@/stores/activityStore";
import { useRolloverStore } from "@/stores/rolloverStore";
import { useActivityLogStore } from "@/stores/activityLogStore";

// stores
const itemsPerPage = 10;

// loop through activity data and remove v-if="actorType != 'system'"
const itemsPerPageRollover = 10;

// paginated data

export default /*#__PURE__*/_defineComponent({
  __name: 'TrackSelectionComponent',
  setup(__props) {


// imports
const activityStore = useActivityStore();
const rolloverStore = useRolloverStore();
const activityLogStore = useActivityLogStore();

// variables
const menuToggle = ref("");
const rolloverData = ref<any[]>([]);
const activityLogData = ref<any[]>([]);
const isLoadingRollover = ref(true);
const isLoadingActivity = ref(true);

// get data from the store
onMounted(async () => {
    isLoadingRollover.value = true;
    await rolloverStore.fetchAllRollovers();
    rolloverData.value = rolloverStore.allRollovers as unknown as any[];
    isLoadingRollover.value = false;

    isLoadingActivity.value = true;
    await activityLogStore.fetchActivityLogs();
    console.log("activity logs: ", activityLogStore.activityLogs);
    activityLogData.value = activityLogStore.activityLogs as unknown as any[];
    isLoadingActivity.value = false;
});

// handle pagination for activity log
const currentPage = ref(1);
const filteredActivityLogData = computed(() => {
  return activityLogData.value.filter((activity) => activity.actorType !== "system");
});

// sort the data by date (newest to oldest)
const sortedActivityLogData = computed(() => {
  return [...filteredActivityLogData.value].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
});

// compute the total number of pages
const totalPages = computed(() =>
  Math.ceil(sortedActivityLogData.value.length / itemsPerPage)
);

// compute the paginated data
const paginatedDataActivityLog = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  return sortedActivityLogData.value.slice(startIndex, endIndex);
});

// go to previous page
function prevPage() {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
}

// go to the next page
function nextPage() {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
}

// filter by learnerRollover status
const filteredRolloverData = computed(() => {
  return rolloverData.value.filter(
    (school) => school.status.learnerRollover === "to_do" && school.isComplete === false
  );
});

// filter by rolloverDate (within a month before or in the past)
const filteredRolloverDataByDate = computed(() => {
  const today = new Date();
  const oneMonthBeforeToday = new Date(today);
  oneMonthBeforeToday.setMonth(today.getMonth() - 1);

  return filteredRolloverData.value.filter((school) => {
    const rolloverDate = new Date(school.rolloverDate);
    return rolloverDate <= today || rolloverDate <= oneMonthBeforeToday;
  });
});

// sort the filtered data by rolloverDate (oldest to newest)
const sortedRolloverData = computed(() => {
  return [...filteredRolloverDataByDate.value].sort(
    (a, b) =>
      new Date(a.rolloverDate).getTime() - new Date(b.rolloverDate).getTime()
  );
});

// handle pagination for sorted data
const currentPageRollover = ref(1);
const paginatedDataRollover = computed(() => {
  const start = (currentPageRollover.value - 1) * itemsPerPageRollover;
  const end = start + itemsPerPageRollover;
  return sortedRolloverData.value.slice(start, end);
});

// calculate total pages
const totalPagesRollover = computed(() => {
  return Math.ceil(sortedRolloverData.value.length / itemsPerPageRollover);
});

// go to the previous page
function prevPageRollover() {
  if (currentPageRollover.value > 1) {
    currentPageRollover.value--;
  }
}

// go to the next page
function nextPageRollover() {
  if (currentPageRollover.value < totalPagesRollover.value) {
    currentPageRollover.value++;
  }
}

// echarts code
onMounted(() => {
    // Check if the chart container exists
    setTimeout(() => {
        type EChartsOption = echarts.EChartsOption;

        var chartDom = document.getElementById('engagementGraph')!;
        // var chartDom2 = document.getElementById('onboardingGraph')!;
        var myChart = echarts.init(chartDom);
        // var myChart2 = echarts.init(chartDom2);
        var option: EChartsOption;
        // var option2: EChartsOption;

        const loginTaskData1 = computed(
            () => activityStore?.getLoginActivityData as unknown as any[]
        );

        console.log("login data 1: ", loginTaskData1.value);

        const last30Days = [];
        const months = [];
        const today = new Date();

        // Function to generate the last 30 days
        function getLast30Days() {
            const dates = [];
            for (let i = 0; i < 30; i++) {
                const date = new Date(today);
                date.setDate(today.getDate() - i);
                dates.push(date.toISOString().split("T")[0]);
            }
            return dates.reverse(); // Oldest to newest
        }

        const allDates = getLast30Days();

        // Map the loginTaskData1 to create a dictionary of login counts
        const loginDataMap = (loginTaskData1.value || []).reduce((map, entry) => {
            map[entry.login_date.value] = entry.count || 0; // Map date to count
            return map;
        }, {} as Record<string, number>);

        // Generate the last 30 days' dates
        for (let i = 29; i >= 0; i--) {
            const date = new Date();
            date.setDate(today.getDate() - i);

            // Format the day as '01', '02', etc.
            const day = date.getDate().toString().padStart(2, '0');
            last30Days.push(day);

            // Check for a new month and store it only once
            if (i === 29 || date.getMonth() !== today.getMonth() - Math.floor(i / 30)) {
                months.push(date.toLocaleString("default", { month: "long" }));
            } else {
                months.push("");
            }
        }

        // Create the series data for the bar chart
        const seriesData = allDates.map((date) => loginDataMap[date] || 0);

        console.log("Series Data for Last 30 Days:", seriesData);

        // bar graph
        option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                type: 'shadow'
                }
            },
            xAxis: [
                {
                type: 'category',
                name: "Month",
                data: allDates,
                axisTick: {
                    alignWithLabel: true
                },
                nameLocation: "middle",
                nameTextStyle: {
                    fontWeight: "bold",
                    fontSize: 12,
                    padding: 30,
                    color: "#4B5563",
                },
                axisLabel: {
                    interval: 0,
                    fontSize: 10,
                    color: "#4B5563",
                    // rotate: 45,
                    formatter: function (value, index) {
                        const date = new Date(value);
                        const day = date.getDate();
                        const month = date.toLocaleString("default", { month: "short" });

                        if (index === 0 || day === 1) {
                        return `${day}\n\n${month}`; // Show month only on the first day and the 1st of a month
                        }
                        return `${day}`; // Show day number on all other labels
                    },
                },
                
                },
            ],
            yAxis: [
                {
                    name: "Students",
                    type: "value",
                    nameLocation: "middle",
                    nameTextStyle: {
                        fontWeight: "bold",
                        fontSize: 12,
                        padding: 20,
                        color: "#4B5563",
                    },
                }
            ],
            series: [
                {
                    name: 'Students',
                    type: 'bar',
                    barWidth: '10px',
                    barGap: "30px",
                    data: seriesData,
                    itemStyle: {
                        borderRadius: [5, 5, 0, 0],
                        color: "#2563EB",
                    },
                }
            ],
            grid: {
                bottom: 100,
            },
            graphic: months.map((month, index) => ({
                type: "text",
                left: `${(index * 100) / 30}%`,
                top: "100%",
                style: {
                text: month,
                font: "bold 12px Arial",
                fill: "#4B5563",
                textAlign: "center",
                },
            })),
        },
        option && myChart.setOption(option);
        // option2 && myChart2.setOption(option2);

    }, 300); // Adjust delay as needed
});

// Date, Champion, School, Notes
const tableDataHeaders = ["Date", "User", "School", "Description"];

// table headers data
const schooolTableHeaders = ["School Name", "Champion", "Status", "Rollover Date"];

// computed property to calculate the count of unique school names
const uniqueSchoolCount = computed(() => {
  const uniqueSchools = new Set(filteredRolloverData.value.map((school:any) => school.school.name));
  return uniqueSchools.size;
});


return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (menuToggle.value == '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("internal_view.track_screen.engagement")), 1)
            ]),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("internal_view.track_screen.changes_made")), 1),
            (isLoadingActivity.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
                ]))
              : (_openBlock(), _createElementBlock("table", _hoisted_11, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableDataHeaders, (header, index) => {
                    return _createElementVNode("th", {
                      key: index,
                      class: "px-6 py-3 text-left text-xs text-gray-600 font-medium"
                    }, _toDisplayString(header), 1)
                  }), 64)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedDataActivityLog.value, (row, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: _normalizeClass([index % 2 === 1 ? 'bg-gray-200 rounded-lg' : '', "text-xs text-gray-600 font-medium"])
                      }, [
                        _createElementVNode("td", {
                          class: _normalizeClass([
                            'px-6 py-3',
                            index % 2 === 1 ? 'rounded-l-lg' : ''
                          ])
                        }, _toDisplayString(new Date(row.createdAt).toISOString().split('T')[0]), 3),
                        _createElementVNode("td", _hoisted_12, [
                          (row.actorDetails)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row.actorDetails.firstName) + " " + _toDisplayString(row.actorDetails.lastName), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("internal_view.track_screen.no_user_assigned")), 1))
                        ]),
                        _createElementVNode("td", _hoisted_15, [
                          (row.school)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(row.school.name), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("internal_view.track_screen.no_school_assigned")), 1))
                        ]),
                        _createElementVNode("td", {
                          class: _normalizeClass([
                            'px-6 py-3',
                            index % 2 === 1 ? 'rounded-r-lg' : ''
                          ])
                        }, [
                          (row.details.metadata.payload && row.details.metadata.payload.designation)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "New " + _toDisplayString(row.details.metadata.payload.designation) + " added - " + _toDisplayString(row.details.metadata.payload.email), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(row.details.note), 1))
                        ], 2)
                      ], 2))
                    }), 128))
                  ])
                ])),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.page")) + " " + _toDisplayString(currentPage.value) + " " + _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.of")) + " " + _toDisplayString(totalPages.value), 1),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: prevPage,
                  disabled: currentPage.value === 1,
                  class: "text-gray-700 text-sm font-semibold border border-gray-300 px-3 py-2 bg-white rounded-lg disabled:opacity-50 mr-3"
                }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.previous")), 9, _hoisted_22),
                _createElementVNode("button", {
                  onClick: nextPage,
                  disabled: currentPage.value === totalPages.value,
                  class: "text-gray-700 text-sm font-semibold border border-gray-300 px-3 py-2 bg-white rounded-lg disabled:opacity-50"
                }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.next")), 9, _hoisted_23)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})